import { inject, Injectable } from "@angular/core";

import { Observable, tap } from "rxjs";

import { environment } from "@environments/environment";

import { ApiCacheService } from "@shared/services/util/api-cache.service";
import { MemberInfoResponse, PostConfig, RequestState } from "@shared/models";

@Injectable({
  providedIn: "root",
})
export class MemberInfoService {
  apiCacheService = inject(ApiCacheService);
  private readonly _baseUrl = environment.memberInfoUrl;

  private readonly requestConfig: PostConfig = {
    cacheId: "seq-his-member-info",
    cacheValidMinutes: 30,
    url: this._baseUrl,
    postBody: {},
  };

  /**
   * Calls memberInfoApi to log instance of member info request and who requested it. Then returns the requested member's info.
   * @param {string} requestedMemberId
   * @param {string} initiatorMemberId
   * @returns Observable<{@link RequestState}<{@link MemberInfoResponse}>>
   */
  getMemberInfo(requestedMemberId: string, initiatorMemberId: string): Observable<RequestState<MemberInfoResponse>> {
    this.requestConfig.postBody = {
      searchTerm: requestedMemberId,
      userId: initiatorMemberId,
      request: 0,
    };
    this.requestConfig.cacheId = `seq-his-member-info-${requestedMemberId}`;
    return this.apiCacheService.post<MemberInfoResponse>(this.requestConfig);
  }
}
